import { render, staticRenderFns } from "./MyDistributors.vue?vue&type=template&id=863af8ba&scoped=true&"
import script from "./MyDistributors.vue?vue&type=script&lang=js&"
export * from "./MyDistributors.vue?vue&type=script&lang=js&"
import style0 from "./MyDistributors.vue?vue&type=style&index=0&id=863af8ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863af8ba",
  null
  
)

export default component.exports